module.exports = "/_next/static/images/b5189264657e129929f486cc8dd4407a-cards@1x.png";